/**
 * Awvent - Business Accounts API
 * Awvent Accounts Apis
 *
 * OpenAPI spec version: v1
 * Contact: djoyrocks@gmail.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { BusinessAccountDto } from './businessAccountDto';

export class BusinessAccountCreateCommand {
    businessAccountDetails?: BusinessAccountDto;
}
